import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MenuEditPageRoutingModule } from './menu-edit-routing.module';

import { MenuEditPage } from './menu-edit.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    MenuEditPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [MenuEditPage]
})
export class MenuEditPageModule {}
